import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    input: {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    addNewButton: {
      ...CommonFonts.darkFont14,
      color: Colors.WHITE,
      padding: `${theme.spacing(5)}px ${theme.spacing(10)}px`,
      maxWidth: theme.spacing(50),
      maxHeight: theme.spacing(13),
      textAlign: 'center',
    },
    titleText: {
      ...CommonFonts.darkFont16,
    },
    selectOptionInput: {
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent',
      },
    },
  })
);

export default useStyles;
